<template>
  <b-col md="12">
    <b-row class="cabinet-title" data-aos="fade-down" my-auto>
      <b-col my-auto md="1">
        <b-img fluid :src="Logo" />
      </b-col>
      <b-col class="name" my-auto>
        {{ name }}
      </b-col>
    </b-row>
    <b-row class="cabinet" data-aos="fade-in">
      <b-col col md="6" cols="12">
        <b-carousel
          id="carousel-fade"
          v-model="slide"
          :interval="2000"
          fade
          controls
          indicators
          background="#ffffff"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
            v-for="picture in Pictures"
            :key="picture.name"
            :img-src="picture"
          ></b-carousel-slide>
        </b-carousel>
      </b-col>
      <b-col col md="6" cols="12" class="description">
        {{ description }}
      </b-col>
    </b-row>
    <b-row>
      <b-col col md="6">
        <div class="info">
          <i class="fa fa-clock-o" aria-hidden="true"></i> {{ horaire }}
        </div>
        <div class="info">
          <i class="fa fa-map-marker" aria-hidden="true"></i>
          {{ adresse }}
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  props: ["name", "description", "horaire", "adresse", "photos", "logo"],
  data() {
    return {
      slide: 0,
    };
  },
  computed: {
    Pictures() {
      var pictures = [];
      var i = 0;
      console.log(this.photos.length);
      for (; i < this.photos.length; i++) {
        console.log(this.photos[i]);
        pictures[i] = require("../assets/images/" + this.photos[i]);
      }
      return pictures;
    },
    Logo() {
      return require("../assets/" + this.logo);
    },
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style scoped lang="stylus">
.name {
  font-size: 1.8rem !important;
}

@media (max-width: 425px) {
.description {
  margin-top: 10px;
  }
.name {
  font-size: 1.2rem !important }
  }

.cabinet-title {
  margin-top:20px;
}

.carousel-item {
  background-size: cover;
  background-position: center center;
}

.cabinet {
  margin-top: 5vh;
}

.cabinet-img {
  width: 100%;
  overflow: hidden;
}

.info {
  padding-left: 35px;
  margin-right: 40px;
  margin-left: 20px;
  margin-top: 10px;
  font-size: 1rem;
}
</style>
